import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client/react";
import { BookOpen, ChevronRight, Loader2 } from "lucide-react";

import { GET_SUBJECTS } from "@/graphql/queries/subjects";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { SubjectIcon } from "@/components/subject-icon";
import { skillsLabel } from "@/lib/students";

export default function SubjectsListPage() {
  const { data, loading } = useQuery(GET_SUBJECTS);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const subjects = data?.subjects ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dalykai</h1>
        <p className="text-muted-foreground">
          Peržiūrėkite dalykus ir jų įgūdžius. Įgūdžiai valdomi konfigūracijos
          faile.
        </p>
      </div>

      {subjects.length === 0 ? (
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12">
            <BookOpen className="h-12 w-12 text-muted-foreground mb-4" />
            <p className="text-lg font-medium">Nėra dalykų</p>
            <p className="text-sm text-muted-foreground">
              Pridėkite dalykų į konfigūracijos failą.
            </p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {subjects.map((subject: any) => {
            const previewSkills = subject.skills.slice(0, 5);
            return (
              <Card key={subject.id}>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <CardTitle className="text-lg">{subject.name}</CardTitle>
                    <SubjectIcon
                      icon={subject.icon}
                      className="h-5 w-5 text-muted-foreground"
                    />
                  </div>
                  <CardDescription>
                    {skillsLabel(subject.skills.length)}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="space-y-2 mb-4">
                    {previewSkills.map((skill: any) => (
                      <div
                        key={skill.id}
                        className="text-sm text-muted-foreground flex items-center gap-2"
                      >
                        <span className="w-2 h-2 rounded-full bg-muted-foreground/50" />
                        {skill.name}
                      </div>
                    ))}
                    {subject.skills.length > 5 && (
                      <p className="text-sm text-muted-foreground">
                        ir dar {subject.skills.length - 5}...
                      </p>
                    )}
                  </div>
                  <Button
                    variant="outline"
                    size="sm"
                    asChild
                    className="w-full"
                  >
                    <Link to={`/subjects/${subject.id}`}>
                      Peržiūrėti visus įgūdžius
                      <ChevronRight className="ml-1 h-4 w-4" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
